export const urlUpdate = (url: string, history: History | any): void => {
  history.pushState({}, '', url);
};
